export default function authorBox() {
  const displaySocialIcons = () => {
    const twitterLink = $('.author .author-bio-link.uf-author-twitter')[0];
    const linkedinLink = $('.author .author-bio-link.uf-author-linkedin')[0];

    if (twitterLink) {
      twitterLink.innerHTML = '<i class="fab fa-twitter"></i>';
    }

    if (linkedinLink) {
      linkedinLink.innerHTML = '<i class="fab fa-linkedin-in"></i>';
    }
  };

  const hasAvatar = () => {
    const avatar = document.querySelector('.author .uf-author-avatar');
    const authorBio = document.querySelector('.author');

    if (avatar) {
      authorBio.classList.add('has-author-avatar');
    }
  };

  const displayAuthorName = () => {
    const nametag = document.createElement('h3');
    let authorName;
    const authorNameNoLink = document.querySelector('.meta .author');
    const linkedAuthorName = document.querySelector('.meta .author a');

    if (authorNameNoLink) {
      authorName = authorNameNoLink.innerText;
    } 

    if (linkedAuthorName) {
      authorName = linkedAuthorName.innerText;
      //the author name shouldn't link to anything, it should just be static 
      authorNameNoLink.removeChild(linkedAuthorName);
      authorNameNoLink.innerText = authorName;
    }

    nametag.innerHTML = authorName;
    $(nametag).insertBefore($('.author .uf-author-bio')[0]);
  };

  if ($('body').hasClass('single-page')) {
    displaySocialIcons();
    displayAuthorName();
    hasAvatar();
  }
}



// WEBPACK FOOTER //
// ./scriptPartials/authorBox.js